import { styled, TableCell } from "@mui/material";

import { colors } from "@/theme/overrides/colors";

export const DividerTableCell = styled(TableCell)(() => ({
  position: "relative",
  "&:not(:last-child)": {
    paddingRight: "16px",
    "&::after": {
      content: '""',
      position: "absolute",
      top: "50%",
      right: "0",
      height: "calc(100% - 32px)",
      borderRight: `2px solid ${colors.theme.neutral.lightest}`,
      transform: "translateY(-50%)",
    },
  },
}));
